import { jsObtainContext, jsCallEntityMethod, pureCallEntityMethod } from 'doric/src/runtime/sandbox';
import { createContext, destroyContext } from "./DoricDriver";
import { DoricStackNode } from './shader/DoricStackNode';
const doricContexts = new Map;
let __contextId__ = 0;
function getContextId() {
    return `context_${__contextId__++}`;
}
export function getDoricContext(contextId) {
    return doricContexts.get(contextId);
}
export class DoricContext {
    constructor(content) {
        this.contextId = getContextId();
        this.pluginInstances = new Map;
        this.headNodes = new Map;
        createContext(this.contextId, content);
        doricContexts.set(this.contextId, this);
        this.rootNode = new DoricStackNode(this);
    }
    targetViewNode(viewId) {
        if (this.rootNode.viewId === viewId) {
            return this.rootNode;
        }
        for (let nodes of this.headNodes.values()) {
            if (nodes.has(viewId)) {
                return nodes.get(viewId);
            }
        }
    }
    get panel() {
        var _a;
        return (_a = jsObtainContext(this.contextId)) === null || _a === void 0 ? void 0 : _a.entity;
    }
    invokeEntityMethod(method, ...otherArgs) {
        const argumentsList = [this.contextId];
        for (let i = 0; i < arguments.length; i++) {
            argumentsList.push(arguments[i]);
        }
        return Reflect.apply(jsCallEntityMethod, this.panel, argumentsList);
    }
    pureInvokeEntityMethod(method, ...otherArgs) {
        const argumentsList = [this.contextId];
        for (let i = 0; i < arguments.length; i++) {
            argumentsList.push(arguments[i]);
        }
        return Reflect.apply(pureCallEntityMethod, this.panel, argumentsList);
    }
    init(data) {
        this.invokeEntityMethod("__init__", data);
    }
    onCreate() {
        this.invokeEntityMethod("__onCreate__");
    }
    onDestroy() {
        this.invokeEntityMethod("__onDestroy__");
    }
    onShow() {
        this.invokeEntityMethod("__onShow__");
    }
    onHidden() {
        this.invokeEntityMethod("__onHidden__");
    }
    build(frame) {
        this.invokeEntityMethod("__build__", frame);
    }
    inAnimation() {
        return !!this.animationSet;
    }
    addAnimation(viewNode, keyFrame) {
        var _a;
        (_a = this.animationSet) === null || _a === void 0 ? void 0 : _a.push({
            viewNode,
            keyFrame,
        });
    }
    teardown() {
        for (let plugin of this.pluginInstances.values()) {
            plugin.onTearDown();
        }
        destroyContext(this.contextId);
    }
}
//# sourceMappingURL=DoricContext.js.map